module.exports = __webpack_public_path__ + "static/img/wyfw4.7b9a319.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wyfw4.png
// module id = DfTQ
// module chunks = 1